export const RsInspectionRouteConstants = {
    AttachmentViewer: "attachment-viewer",
    SubmittedProposal: "submitted-proposal",
    SubmittedInvoice: "submitted-invoice",
    SubmittedWithdrawal: "submitted-withdrawal",
    SubmittedCancellation: "submitted-cancellation",
    SubmittedChangeInspectionDate: "submitted-change-inspection-date",
    DeclineProposal: "decline-proposal",
    Proposal: "proposal",
    Invoice: "invoice",
    Inspection: "inspection",
    InspectionDocuments: "inspection-documents",
    InspectionReport: "inspection-report",
    InspectionReportUnavailable: "inspection-report-unavailable",
    InspectionClosed: "inspection-closed",
    WithdrawInspection: "withdraw-inspection",
    CancelInspection: "cancel-inspection",
    ChangeInspectionDate: "change-inspection",
    CloseRequest: "close-request",
    NotFound: "not-found"
}